import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { MAX_NAME_LENGTH, MIN_NAME_LENGTH } from 'pages/Contacts/constants'
import { createGenericNameSchema } from 'utils/yupSchemas/createGenericNameSchema'

export const updateBeneficiarySchema = (t: TFunction<'translation', undefined>) => {
  const alias = createGenericNameSchema(t('alias'), t, MIN_NAME_LENGTH, MAX_NAME_LENGTH)
  const businessName = createGenericNameSchema(
    t('businessName'),
    t,
    MIN_NAME_LENGTH,
    MAX_NAME_LENGTH
  )
  const firstName = createGenericNameSchema(t('firstName'), t, 2)
  const lastName = createGenericNameSchema(t('lastName'), t, 2)
  const password = yup.string().trim().required()

  const formFields = {
    alias,
    businessName,
    firstName,
    lastName,
    password,
  }

  return yup.object(formFields)
}
